class FormSubmit {
  // * No specific form, handles all form submits that return a success and message. Setup form submit call in index.js
  // * If you want to do something specific with a form, do not use this file, make another

  constructor(target) {
    if (target) {
      this.form = target;
      this.tokenElement = target.querySelector('[name=g-recaptcha-response], [name=g-Recaptcha-Response]');
      this.versionElement = target.querySelector('[name=g-recaptcha-version]');
      this.v2Container = target.querySelector('.recaptcha-v2-container');

      this.form.addEventListener("submit", (e) => {
        e.preventDefault();
        this.recaptcha();
      });
    }
  }

  recaptcha() {
    if (this.tokenElement == null) {
      this.submit();
    }

    // If versionElement is null, that means the form is using the old recaptcha method and expects v3
    if (!this.versionElement || this.versionElement.value === 'v3') {
      grecaptcha.ready(() => {
        grecaptcha.execute(window.recaptchaSiteKey.v3, { action: 'submit' }).then((token) => {
          this.tokenElement.value = token;
          this.submit();
        });
      });
    } else {
      this.showV2Challenge();
    }
  }

  showV2Challenge() {
    this.v2Container.style.display = 'block';

    // Render the v2 checkbox widget
    grecaptcha.render(this.v2Container, {
        sitekey: window.recaptchaSiteKey.v2,
        callback: async (v2Token) => {
            this.tokenElement.value = v2Token;
            this.versionElement.value = 'v2';

            this.submit();
        },
        'expired-callback': () => {
            // Token expired before user resubmitted — reset widget
            grecaptcha.reset();
        }
    });
  }

  async submit() {
    const button = this.form.querySelector("button[type=submit]");
    const callout = this.form.querySelectorAll(".callout");
    const data = new FormData(this.form);
    const action = this.form.getAttribute("action");
    const formMethod = this.form.getAttribute("method");

    const requiredCheckbox = this.form.querySelector("input[type='checkbox']");

    if (requiredCheckbox) {
      const requiredText = this.form.querySelector("#checkboxRequired");
      if (!requiredCheckbox.checked && requiredText != null) {
        this.renderMessage(requiredText.textContent, "error");
        return;
      }
    }

    if (callout) {
      callout.forEach(el => el.remove());
    }

    button.disabled = true;
    button.classList.add("button--loading");

    try {
      const res = await fetch(action, {
        method: formMethod,
        body: data,
      });

      const response = await res.json();

      if (response.requiresV2Fallback) {
        return this.showV2Challenge();
      }

      if (response.success) {
        this.renderMessage(response.message, "success");
        this.form.reset();
      } else {
        this.renderMessage(response.message, "error");
      }
      setTimeout(() => {
        button.classList.remove("button--loading");
        button.disabled = false;
      }, 150);
    } catch (ex) {
      console.error(ex);
      this.renderMessage(`Server error: ${ex}`, "error");
    }
  }

  renderMessage(message, type) {
    this.form.insertAdjacentHTML("beforeend", `<div class="callout callout--${type}">${message}</div>`);
  }
}

export default FormSubmit;
